/** Locations needed for CRM wrapper processing */
export enum TABLocation {
  Mobi = 538,
  Desktop = 285,
}

/** Required to phase out native bottom tab navigation */
export const NativeAppVersionWithRemovedTabNav = 257
